exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cover[data-v-4af0cede]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:var(--cover-height);padding:0}.cover>*[data-v-4af0cede]{margin-top:var(--cover-gap);margin-bottom:var(--cover-gap)}.cover[data-v-4af0cede]>:first-child:not(.centered){margin-top:0}.cover[data-v-4af0cede]>:last-child:not(.centered){margin-bottom:0}.cover>.centered[data-v-4af0cede]{margin-top:auto;margin-bottom:auto}", ""]);

// exports
